goog.provide("shadow.js.shim.module$src$svg$wpp$content_actions$copy_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content_actions$copy_svg");
shadow.js.shim.module$src$svg$wpp$content_actions$copy_svg = shadow.js.nativeProvides["src/svg/wpp/content-actions/copy.svg"] = shadow$bridge("src/svg/wpp/content-actions/copy.svg");
module$shadow_js_shim_module$src$svg$wpp$content_actions$copy_svg.default = shadow.js.shim.module$src$svg$wpp$content_actions$copy_svg;
